import React, { useState } from "react";
import { platformAPI } from "../services/api";

/**
 * Sends the owner the "confirm your email" message again (a shop made by hand
 * never sent one; an owner may have lost theirs). Says what happened beside
 * the button, since mail can be off or the address wrong.
 */
export default function SendConfirmationButton({ shopId, className = "" }) {
  const [state, setState] = useState({ busy: false, text: "", ok: true });

  const send = async () => {
    setState({ busy: true, text: "", ok: true });

    try {
      const { data } = await platformAPI.sendOwnerVerification(shopId);
      setState({
        busy: false,
        ok: true,
        text: data.already_verified ? "Already confirmed." : `Sent to ${data.email}.`,
      });
    } catch (err) {
      setState({ busy: false, ok: false, text: err.response?.data?.error || "Could not send the email." });
    }
  };

  return (
    <span className={`inline-flex flex-wrap items-center gap-2 ${className}`}>
      <button
        type="button"
        onClick={send}
        disabled={state.busy}
        className="px-3 py-1.5 rounded-lg bg-sky-50 text-sky-800 text-sm font-medium hover:bg-sky-100 disabled:opacity-50"
      >
        {state.busy ? "Sending…" : "✉️ Send confirmation email"}
      </button>
      {state.text && <span className={`text-sm ${state.ok ? "text-green-700" : "text-red-600"}`}>{state.text}</span>}
    </span>
  );
}
